<template>
  <div style="padding: 20px">
    <WmsTable
      :columns="taskRecordsColumns"
      :dataSource="detail"
      :isPagination="false"
      :isExpanded="false"
      :hasHeader="false"
    >
      <template #action="{ record,index }">
        <el-button type="text" :disabled="record.status != 0" @click="finish(record,index)">组合完成</el-button>
      </template>
    </WmsTable>
    <el-button
      @click="close"
      type="primary"
      style="float: right; margin-top: 10px"
      >确定</el-button
    >
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import { Table } from "ant-design-vue";
import ImgPreviews from "@/components/ImgPreviews";
import { taskRecordsColumns } from "./combinTable";
import { pickTaskPage, doPackFinish } from "@/apis/combination";
export default {
  name: "detail",
  components: { WmsTable, [Table.name]: Table, ImgPreviews },
  data() {
    return {
      taskRecordsColumns,
      detail: [],
      formInline: {
        remark: "",
      },
      query: {
        current: 1,
        pageNum: 99,
      },
    };
  },
  mounted() {},
  methods: {
    print() {
      this.$message.warning("开发中");
    },
    finish(record,index) {
      console.log(index)
      let params = {
        packCode: record.packCode,
        pickCode: record.pickCode,
        pkgCode: record.pkgCode
      };
      doPackFinish(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.$emit("doPackFinish");
          this.detail[index].status = 1
        }
      });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.abnormalImage {
  display: flex;
}
</style>
